
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/reusableComponents/alerts',[
        "Vue",
        "vuex",
        'helpers',
    ], function(Vue, vuex, helpers) {
        return {
            name: 'alerts',
            template: template,
            props: {alerts: {required: true}},
            data: function(){
                return {
                    defaultTitles: {
                        'warn': app.localization.roomReservation.pmsCheckIn.errors.leadingHeader.warnHeader,
                        'success': app.localization.roomReservation.pmsCheckIn.errors.leadingHeader.successHeader,
                        'error': app.localization.roomReservation.pmsCheckIn.errors.leadingHeader.errorHeader
                    }
                }
            },
            methods: {
                handleRemove: function(alert){
                    this.$store.dispatch('alerts/removeAlert',alert);
                }
            },
        };
    });
})('<div class="messages-container"> <div v-for="alert in alerts" :class="[\'alert\', \'alert-\'+alert.type]" role="alert" aria-live="polite" :key="alert._id"> <button type="button" class="close" @click="handleRemove(alert)">&times;</button> <strong class="error-title">{{ defaultTitles[alert.type] }}</strong> {{alert.message}} </div> </div>');
